import { getFullPath } from "../routes";
import { getLinks } from "./links";
import { Link } from "react-router-dom";
import { usePermissions } from "../users/hooks";

export function HomePage() {
  const permissions = usePermissions();
  if (permissions.isLoading) {
    return <p>Loading...</p>;
  }

  const links = getLinks(permissions.data?.accessLevel);

  return (
    <>
      <h3>Home</h3>
      <ul className="list-styled ps-4 mt-2">
        {links.map((link, index) => (
          <li key={index}>
            <Link to={getFullPath(link.route)} className="link-primary">
              {link.caption}
            </Link>
          </li>
        ))}
      </ul>
    </>
  );
}
